import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { CartResumeComponent } from '../resume/cart.resume.component';
import { CartResumeService } from '../../shared/services/cart-resume.service';
import { PaymentResumeComponent } from '../../payment/resume/payment.resume.component';
import { Observable } from 'rxjs/Observable';
import { PaymentMethodModel } from '../../shared/models/payment-method.model';
import { observable } from 'rxjs/symbol/observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ResumeUpdaterService {
    private updatingSource: Subject<null> = new Subject();
    private updatedSource: Subject<null> = new Subject();
    private clearingSource: Subject<null> = new Subject();
    private clearedSource: Subject<null> = new Subject();
    private indexingSource: Subject<null> = new Subject();
    private indexedSource: Subject<null> = new Subject();
    private validatingCouponSource: Subject<string> = new Subject();
    private validatedCouponSource: Subject<string> = new Subject();
    private invalidCouponSource: Subject<string> = new Subject();
    public updating$ = this.updatingSource.asObservable();
    public updated$ = this.updatedSource.asObservable();
    public clearing$ = this.clearingSource.asObservable();
    public cleared$ = this.clearedSource.asObservable();
    public indexing$ = this.indexingSource.asObservable();
    public indexed$ = this.indexedSource.asObservable();
    public validatingCoupon$ = this.validatingCouponSource.asObservable();
    public validatedCoupon$ = this.validatedCouponSource.asObservable();
    public invalidCoupon$ = this.invalidCouponSource.asObservable();

    constructor(
        protected cartResumeService: CartResumeService
    ) {}

    /**
     * This call API to update total by payment method rules.
     **/
    public updateBySelectedPaymentMethod(paymentMethod: PaymentMethodModel) {
        this.updatingSource.next(null);
        return new Observable(observable => {
            this.cartResumeService
                .updateBySelectedPaymentMethod(paymentMethod)
                .subscribe(() => {
                    this.updatedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.next(null);
                        observable.complete();
                    });
                }, () => {
                    this.updatedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.error(null);
                        observable.complete();
                    });
                });
        });
    }
    /**
     * This call API to update total by coupon.
     **/
    public updateByCouponCode(couponCode: string) {
        this.updatingSource.next(null);
        this.validatingCouponSource.next(null);
        return new Observable(observable => {
            this.cartResumeService
                .updateByCouponCode(couponCode)
                .subscribe(() => {
                    this.validatedCouponSource.next(null);
                    this.updatedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.next(null);
                        observable.complete();
                    });
                }, () => {
                    this.invalidCouponSource.next(couponCode);
                    this.updatedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.error(null);
                        observable.complete();
                    });
                });
        });
    }
    /**
     * This call API to update total by coupon.
     **/
    public removeCouponCode() {
        this.updatingSource.next(null);
        return new Observable(observable => {
            this.cartResumeService
                .removeCouponCode()
                .subscribe(() => {
                    this.updatedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.next(null);
                        observable.complete();
                    });
                }, () => {
                    this.updatedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.error(null);
                        observable.complete();
                    });
                });
        });
    }
    /**
     * This call API to update total by payment method rules.
     **/
    public clearPaymentMethodDiscount() {
        this.clearingSource.next(null);
        return new Observable(observable => {
            this.cartResumeService
                .clearPaymentMethodDiscount()
                .subscribe(() => {
                    this.clearedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.next(null);
                        observable.complete();
                    });
                }, () => {
                    this.clearedSource.next(null);
                    this.refresh().subscribe(() => {
                        observable.error(null);
                        observable.complete();
                    });
                });
        });
    }
    /**
     * This update total and subtotal using API.
     **/
    public refresh(): Observable<any> {
        this.indexingSource.next(null);
        return new Observable(observable => {
            this.cartResumeService.index().subscribe((response: Response) => {
                let index = response.json().data;
                this.indexedSource.next(index);
                observable.next(index);
                observable.complete();
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/cart/services/cart-resume-updater.service.ts